/**
 * Resolve which Meta Pixel ID the widget should use.
 * Basketmouth host already inits 27525151890490470 — prefer host/config/domain over shared env.
 */
export function resolveFbPixelId(configPixelId?: string): string | undefined {
  if (typeof window !== "undefined") {
    const host = window.location?.hostname || "";
    if (host === "basketmouth.money" || host.endsWith(".basketmouth.money")) {
      return "27525151890490470";
    }
  }

  const fromConfig = (configPixelId || "").trim();
  if (fromConfig) {
    return fromConfig;
  }

  const fromEnv = (process.env.REACT_APP_FB_PIXEL_ID || "").trim();
  return fromEnv || undefined;
}

/**
 * True when the embed host already loaded fbevents + init (e.g. Basketmouth index.html).
 */
export function hostPixelAlreadyReady(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return typeof (window as any).fbq === "function";
}
